import React from "react";
import { BnbLabel } from "../../../utils/labels";
import { useBnbSelector } from "../../../redux/store";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import SpecList from "./SpecList";
import { trackExpandSpecCategory } from "../../../utils/tracking";
import { formatStandardEquipmentList, getEcoSpecs } from "../../../../../../common-deprecated/utils";
import { hasAlternativeEcoSpecFlow } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";

import { SummaryEcoSpecs } from "./SummaryEcoSpecs";

const SummarySpecs = (): JSX.Element | null => {
    const standardEquipment = useBnbSelector(({ basket, specs, items }) => {
        const unformattedStandardEquipment = CarDataConsolidator.filterStandardEquipmentSpecs(
            basket,
            items,
            specs.standardEquipment,
        ).filter((extra) => CarDataConsolidator.isAvailable(extra, basket.colour, basket.upholstery).available);
        return formatStandardEquipmentList(unformattedStandardEquipment);
    });
    const techSpecs = useBnbSelector((state) => state.specs.techSpecs);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const alternativeEcoSpecFlow = hasAlternativeEcoSpecFlow(commonSettings);

    const ecoSpecs = getEcoSpecs(techSpecs, true, alternativeEcoSpecFlow);
    const filteredTechSpecs = ecoSpecs
        ? techSpecs.filter((spec) => !ecoSpecs?.map((ecoSpec) => ecoSpec.internalCode).includes(spec.internalCode))
        : techSpecs;

    if (filteredTechSpecs.length < 1 && standardEquipment.length < 1 && !ecoSpecs) return null;

    return (
        <>
            {filteredTechSpecs.length > 0 && (
                <SpecList
                    specs={filteredTechSpecs}
                    title={<BnbLabel label="techSpecs" />}
                    trackOpen={() => trackExpandSpecCategory("techSpecs")}
                />
            )}

            {/* Standard specs have subcategories instead of main categories. */}
            {standardEquipment.map((category) => (
                <SpecList
                    key={category.id}
                    specs={category.subCat || []}
                    title={category.title}
                    singleColumn
                    trackOpen={() =>
                        trackExpandSpecCategory(
                            category.internalCode === "EXT" ? "exterior-equipment" : "interior-equipment",
                        )
                    }
                />
            ))}
            <SummaryEcoSpecs ecoSpecs={ecoSpecs} alternateFlow={alternativeEcoSpecFlow} />
        </>
    );
};

export default SummarySpecs;
